import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

i18n
  // Load translation using http backend
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Fallback language
    fallbackLng: 'en',

    // Don't set default language - let LanguageDetector handle it

    // Available languages
    supportedLngs: ['en', 'es', 'fr', 'de'],

    // Allow empty strings as valid values
    returnEmptyString: false,

    // Debug mode (only in development)
    debug: process.env.NODE_ENV === 'development',

    // Namespace configuration
    defaultNS: 'common',
    ns: ['common', 'auth', 'lobby', 'game', 'chat', 'settings', 'landing', 'gameCreation', 'bots', 'bibleMatchNTell'],

    // Only fetch namespace files for the active language at a time — with
    // `preload` set to all supported languages, every namespace was being
    // fetched for all 4 languages on every load (40 requests instead of 10),
    // regardless of which language was actually in use. Switching languages
    // still works fine without this: i18next-http-backend fetches a
    // language's resources on demand the first time changeLanguage() needs
    // them, and useSuspense (below) covers that brief load.
    load: 'languageOnly',

    // Backend configuration for loading translation files
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Language detection configuration
    detection: {
      // Order of language detection methods - navigator first for browser language, then localStorage
      order: ['navigator', 'localStorage', 'htmlTag', 'querystring', 'cookie'],

      // Cache user language in localStorage
      caches: ['localStorage'],

      // localStorage key
      lookupLocalStorage: 'gamelobby_language',

      // Check for exact match first, then language code only
      checkWhitelist: true,

      // Don't detect from subdomain
      lookupFromSubdomainIndex: 0,

      // Exclude certain detection methods
      excludeCacheFor: ['cimode'],

      // Convert country codes to language codes (e.g., 'en-US' -> 'en')
      convertDetectedLanguage: (lng) => {
        // Extract language code only (before the dash)
        const langCode = lng.split('-')[0].toLowerCase()

        // Map supported languages
        const supportedLanguages = ['en', 'es', 'fr', 'de']

        // Return the language if supported, otherwise fall back to English
        return supportedLanguages.includes(langCode) ? langCode : 'en'
      },
    },

    // React configuration
    react: {
      // Use suspense for async loading
      useSuspense: true,

      // Bind i18n instance to react
      bindI18n: 'languageChanged',

      // Bind i18n store to react
      bindI18nStore: '',

      // Escape passed in values to avoid XSS injection
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'em', 'span'],
    },

    // Interpolation configuration
    interpolation: {
      // React already escapes values
      escapeValue: false,

      // Formatting functions
      format: function(value, format, lng) {
        if (format === 'uppercase') return value.toUpperCase()
        if (format === 'lowercase') return value.toLowerCase()
        if (format === 'capitalize') return value.charAt(0).toUpperCase() + value.slice(1)
        return value
      }
    },

    // Pluralization
    pluralSeparator: '_',

    // Key separator
    keySeparator: '.',

    // Namespace separator
    nsSeparator: ':',

    // Fallback to key if translation missing in development
    saveMissing: process.env.NODE_ENV === 'development',

    // Missing key handler for development
    missingKeyHandler: process.env.NODE_ENV === 'development'
      ? (lng, ns, key, fallbackValue) => {
          console.warn(`Missing translation: ${ns}:${key} for language: ${lng}`)
        }
      : undefined,
  })

export default i18n